import { ContractFontText, ContractFontTitle } from "../css/ContractStyle";

const Contract = () => {
  return (
    <div>
      <ContractFontTitle>X-RAI API 개인정보 처리방침</ContractFontTitle>
      <ContractFontText>
        X-RAI API는 개인정보 보호법 제30조에 따라 정보주체의 개인정보를 보호하고
        이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과
        같이 개인정보 처리지침을 수립·공개합니다.
      </ContractFontText>
      <ContractFontTitle> ― 개인정보의 처리 목적 ―</ContractFontTitle>
      <ContractFontText>
        제1조(개인정보의 처리목적) X-RAI API는 다음의 목적을 위하여 개인정보를
        처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는
        이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에
        따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
      </ContractFontText>
      <ContractFontText>
        1. 고충처리 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한
        연락·통지, 처리결과 통보 등의 목적으로 개인정보를 처리합니다.
      </ContractFontText>
      <ContractFontText>
        2. 통계분석 이용자에게 보다 나은 서비스를 제공하기 위하여 홈페이지 개선
        및 보완을 위한 통계분석, 이용자와의 원활한 소통을 위해 개인정보를
        처리합니다.
      </ContractFontText>
      <ContractFontTitle>― 개인정보의 처리 및 보유 기간 ―</ContractFontTitle>
      <ContractFontText>
        제2조(개인정보의 처리 및 보유기간)
        <br /> ① X-RAI API는 법령에 따른 개인정보 보유․이용기간 또는
        정보주체로부터 개인정보 수집 시에 동의받은 개인정보 보유․이용기간 내에서
        개인정보를 처리․보유합니다.
        <br /> ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
      </ContractFontText>
      <ContractFontText>
        1. 홈페이지 회원 가입 및 관리 : 회원가입 서비스 시작부터 센터 폐관
        시까지 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지{" "}
        <br /> 1) 관계 법령 위반에 따른 수사․조사 등이 진행 중인 경우에는 해당
        수사․조사 종료 시까지
        <br /> 2) 홈페이지 이용에 따른 채권․채무관계 잔존시에는 해당
        채권․채무관계 정산시까지 <br />
        2. 재화 또는 서비스 제공 : 재화․서비스 공급완료 및 요금결제․정산
        완료시까지 다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지
        <br />
        1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시․광고,
        계약내용 및 이행 등 거래에 관한 기록 - 표시․광고에 관한 기록 : 6월 -
        계약 또는 청약철회, 대금결제, 재화 등의 공급기록 : 5년 - 소비자 불만
        또는 분쟁처리에 관한 기록 : 3년 <br />
        2) 「통신비밀보호법」제41조에 따른 통신사실확인자료 보관 - 가입자
        전기통신일시, 개시․종료시간, 상대방 가입자번호, 사용도수, 발신기지국
        위치추적자료 : 1년 - 컴퓨터통신, 인터넷 로그기록자료, 접속지 추적자료 :
        3개월
        <br /> 3) 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」시행령
        제29조에 따른 본인확인정보 보관 : 게시판에 정보 게시가 종료된 후 6개월
        <br />
        3. [개인정보 처리업무] : 센터 폐관 시까지 ― 정보주체의 권리․의무 및
        행사방법 ― 제3조(정보주체의 권리․의무 및 행사방법)
        <br /> ① 정보주체는 X-RAI API에 언제든지 다음 각 호의 개인정보 보호 관련
        권리를 행사할 수 있습니다. <br />
        1. 개인정보 열람요구 2. 오류 등의 정정 요구 3. 삭제요구 4. 처리정지 요구
        <br />② 제1항에 따른 권리 행사는 X-RAI API에 대해 개인정보 보호법
        시행규칙 별지 제8호 서식에 따라 서면, 전자우편, 모사전송(FAX) 등을 통해
        하실 수 있으며 X-RAI API는 이에 대해 지체 없이 조치하겠습니다.
        <br /> ③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한
        경우에 X-RAI API는 정정 또는 삭제를 완료할 때까지 당해 개인정보를
        이용하거나 제공하지 않습니다.
        <br /> ④제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은
        자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙
        별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
      </ContractFontText>
      <ContractFontTitle>― 처리하는 개인정보 항목 ―</ContractFontTitle>
      <ContractFontText>
        제4조(처리하는 개인정보 항목) X-RAI API는(은) 다음의 개인정보 항목을
        처리하고 있습니다.
      </ContractFontText>
      <ContractFontText>
        1. 홈페이지 회원 가입 및 관리(추후 회원가입 서비스 제공 시) ·필수항목 :
        성명, 생년월일, 아이디, 비밀번호, 주소, 전화번호, 이메일주소, 핸드폰번호
      </ContractFontText>
      <ContractFontText>
        2. 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어
        수집될 수 있습니다. ·IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록,
        불량 이용기록 등
        <br /> ① X-RAI API는 개인정보 보유기간의 경과, 처리목적 달성 등
        개인정보가 불필요하게 되었을 때 지체없이 해당 개인정보를 파기합니다.
        <br /> ② 정보주체로부터 동의받은 개인정보 보유기간이 경과하거나
        처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속
        보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로
        옮기거나 보관장소를 달리하여 보존합니다.
        <br /> ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다.
      </ContractFontText>
      <ContractFontTitle>― 개인정보 파기에 관한 사항 ―</ContractFontTitle>
      <ContractFontText>
        제5조(개인정보의 파기)
        <br />
        1. 파기절차 X-RAI API는 파기 사유가 발생한 개인정보를 선정하고, X-RAI
        API의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다.
        <br /> 2. 파기방법 X-RAI API는 전자적 파일 형태로 기록․저장된 개인정보는
        기록을 재생할 수 없도록 파기하며, 종이 문서에 기록․저장된 개인정보는
        분쇄기로 분쇄합니다.
      </ContractFontText>
      <ContractFontTitle> ― 안전성 확보조치에 관한 사항 ―</ContractFontTitle>
      <ContractFontText>
        제6조(개인정보의 안전성 확보조치) X-RAI API는 개인정보의 안전성 확보를
        위해 다음과 같은 조치를 취하고 있습니다. <br />
        1. 관리적 조치 : 내부관리계획 수립․시행, 정기적 직원 교육 등 <br />
        2. 기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템
        설치, 고유식별정보 등의 암호화, 보안프로그램 설치 등의 프로그램 운영{" "}
        <br />
        3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제
      </ContractFontText>
      <ContractFontTitle>
        ― 개인정보 보호책임자에 관한 사항 ― 제7조(개인정보 보호책임자)
      </ContractFontTitle>
      <ContractFontText>
        ① X-RAI API는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
        처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이
        개인정보 보호책임자를 지정하고 있습니다. ■ 개인정보 보호 담당부서 및
        책임자 • 책임자 : X-RAI API 고봉균 대표 • 담당자 : X-RAI API 유지혜 •
        연락처 : 062-530-3470 • 이메일 : startup.Xrai@gmail.com
        <br /> ② 정보주체께서는 X-RAI API의 서비스(또는 사업)을 이용하시면서
        발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을
        개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다.
      </ContractFontText>
    </div>
  );
};

export default Contract;
